/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig } from './lais/httpHelpers';

class ConversationListingLinksAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  basePath(conversationId) {
    return resourcePath(this.url, conversationId, 'listing_links');
  }

  get(conversationId) {
    return axios.get(this.basePath(conversationId), requestConfig());
  }

  create(conversationId, payload = {}) {
    return axios.post(this.basePath(conversationId), payload, requestConfig());
  }

  update(conversationId, linkId, payload = {}) {
    return axios.patch(
      resourcePath(this.basePath(conversationId), linkId),
      payload,
      requestConfig()
    );
  }

  reject(conversationId, linkId, payload = {}) {
    return axios.delete(resourcePath(this.basePath(conversationId), linkId), {
      ...requestConfig(),
      data: payload,
    });
  }
}

export default new ConversationListingLinksAPI();
